import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { CalendarDays, Clock, MapPin, Users } from "lucide-react";
import { getEvents } from "../lib/api";
import RsvpModal from "./RsvpModal";

const EVENT_ID = "evt_new_home_ribbon_cutting";

export const RibbonCuttingRsvp = () => {
  const [open, setOpen] = useState(false);
  const { data: events = [] } = useQuery({ queryKey: ["events"], queryFn: () => getEvents() });
  const event = events.find((e) => e.id === EVENT_ID);
  if (!event) return null;

  return (
    <section className="bg-white py-20 border-t border-black/10" data-testid="ribbon-cutting-section">
      <div className="container-x grid gap-10 md:grid-cols-12 items-center">
        <div className="md:col-span-5">
          <img src={event.image} alt="Change Center grand opening" className="w-full aspect-[4/3] object-cover rounded-xl" />
        </div>
        <div className="md:col-span-7">
          <span className="overline text-[#6B21A8]">You're invited</span>
          <h2 className="mt-3 font-display text-4xl md:text-5xl font-bold" data-testid="ribbon-cutting-title">{event.title}</h2>
          <div className="mt-5 space-y-2 text-black/75">
            <p className="flex items-center gap-2"><CalendarDays className="h-4 w-4 text-[#6B21A8]" /> Tuesday, December 1, 2026</p>
            <p className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#6B21A8]" /> {event.time}</p>
            <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#6B21A8]" /> {event.location}</p>
          </div>
          <p className="mt-5 max-w-xl text-black/70">{event.description}</p>
          <button onClick={() => setOpen(true)} className="btn-primary mt-7 inline-flex" data-testid="ribbon-cutting-rsvp-btn">
            <Users className="h-4 w-4" /> RSVP — it's free
          </button>
        </div>
      </div>
      {open && <RsvpModal event={event} onClose={() => setOpen(false)} />}
    </section>
  );
};
